/**
 * Generated by orval v8.12.3 🍺
 * Do not edit manually.
 * 十八线_接口文档
 * 十八线——小众旅游
 * OpenAPI spec version: 版本号:0.0.1
 */
import type {
  AjaxResult,
  RewardOrderDetailPathParameters,
  RewardOrderListParams,
  RewardOrderPayablePathParameters,
  TableDataInfo
} from '../../../types/api';

import { orvalMutator } from '../../../utils/orval-mutator';



  export const get = () => {
/**
 * @summary 打赏订单详情
 */
const rewardOrderDetail = (
    { orderId }: RewardOrderDetailPathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/order/${orderId}`, method: 'GET'
    },
      );
    }
  /**
 * @summary 订单对应的商家应付流水
 */
const rewardOrderPayable = (
    { orderId }: RewardOrderPayablePathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/order/${orderId}/payable`, method: 'GET'
    },
      );
    }
  /**
 * @summary 打赏订单列表
 */
const rewardOrderList = (
    params: RewardOrderListParams,
 ) => {
      return orvalMutator<TableDataInfo>(
      {url: `/travel18/reward/order/list`, method: 'GET',
        params
    },
      );
    }
  return {rewardOrderDetail,rewardOrderPayable,rewardOrderList}};
export type RewardOrderDetailResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardOrderDetail']>>>
export type RewardOrderPayableResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardOrderPayable']>>>
export type RewardOrderListResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardOrderList']>>>
